import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { verificationService } from '../services/verificationService';
import LoadingSpinner from '../components/common/LoadingSpinner/LoadingSpinner';
import ErrorAlert from '../components/common/ErrorAlert/ErrorAlert';
import VerificationTabs from '../components/Verification/VerificationTabs/VerificationTabs';

const VerificationPage = () => {
  const [data, setData] = useState({
    pending: [],
    approved: [],
    rejected: [],
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const [pending, approved, rejected] = await Promise.all([
        verificationService.getPending(),
        verificationService.getApproved(),
        verificationService.getRejected(),
      ]);
      setData({ pending: pending || [], approved: approved || [], rejected: rejected || [] });
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleApprove = async (request) => {
    try {
      await verificationService.approve(request._id);
      toast.success('Заявка одобрена');
      await load();
    } catch (e) {
      toast.error(e?.response?.data?.message || 'Ошибка при одобрении');
    }
  };

  const handleReject = async (request, reason) => {
    try {
      await verificationService.reject(request._id, reason);
      toast.success('Заявка отклонена');
      await load();
    } catch (e) {
      toast.error(e?.response?.data?.message || 'Ошибка при отклонении');
    }
  };

  return (
    <>
      <h1 className="mb-3">Верификация пользователей</h1>
      <Card>
        <Card.Body>
          {loading && !data.pending.length ? (
            <LoadingSpinner />
          ) : (
            <>
              <ErrorAlert error={error} />
              <VerificationTabs data={data} onApprove={handleApprove} onReject={handleReject} />
            </>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default VerificationPage;

